import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import LoginInfo from '../../components/LoginInfo/LoginInfo';
import { AppConfig } from '../../config';
import logoCpay from '../../img/footer/footerLogo.svg';
import logoPayblock from '../../img/footer/payblock-logo.png';
import logoNfg from '../../img/nfgpay-svg/nfg_logo_black.svg';
import logoFinvaro from '../../img/finvaro/finvaro-logo-black.png';
import logoClarnium from '../../img/clarnium/clarnium-logo-color.png';
import logoInex from '../../img/inex/inex-logo.svg';
import logoInsta from '../../img/instaXchange/instaXchange-logo.png';
import logoCoinera from '../../img/coinera/coinera-logo.png';
import useWindowSize from '../../utils/resizeHook';
import LanguageSelector from '../../components/LanguageSelector';
import './style.scss';
import { identity } from "../../utils/getIdentity";

const logos = {
  cpay: !AppConfig?.hideLogo ? logoCpay : logoPayblock,
  nfg: logoNfg,
  finvaro: logoFinvaro,
  clarnium: logoClarnium,
  inex: logoInex,
  insta: logoInsta,
  coinera: logoCoinera
}

const AuthPagesWrapper = ({ childComponent: ChildComponent, withWelcomeBlock }) => {
  const [isHideWelcomeBlock, setIsHideWelcomeBlock] = useState(!withWelcomeBlock);
  const [accountType, setAccountType] = useState(null);
  const { isSm } = useWindowSize();

  const toggleWelcomeBlock = status => setIsHideWelcomeBlock(status);

  useEffect(() => {
    localStorage.setItem('wizzardShow', true);
    localStorage.setItem('wizzardShowInex', true);
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div className={`auth-wrapper auth-wrapper-${identity}`}>
        <div className="auth-wrapper__block">
          <div className="auth-wrapper__form-block">
            <div className="auth-wrapper__header">
              <a href={AppConfig.identity === 'cpay' && !AppConfig?.hideLogo ? 'https://gemewallet.com/' : null} target='_blank' rel="noopener noreferrer">
                <img
                  className={`auth-wrapper__logo-top auth-wrapper__logo-top-${AppConfig?.hideLogo} auth-wrapper__logo-top--${identity}`}
                  src={logos[AppConfig.identity]} alt="Logo" />
              </a>
              <LanguageSelector />
            </div>
            <ChildComponent
              toggleWelcomeBlock={toggleWelcomeBlock}
              setAccountType={setAccountType}
              accountType={accountType}
            />
          </div>
          {!isSm && withWelcomeBlock && !isHideWelcomeBlock && (
            <div className={`auth-wrapper__welcome-block auth-wrapper__welcome-block-${identity}`}>
              <LoginInfo accountType={accountType} />
              <div>
                <a href={AppConfig.identity === 'cpay' && !AppConfig?.hideLogo ? 'https://gemewallet.com/' : null} target='_blank'
                   rel="noopener noreferrer">
                  <img className={`auth-wrapper__logo-bottom auth-wrapper__logo-bottom-${AppConfig?.hideLogo} auth-wrapper__logo-bottom--${identity}`}
                       src={logos[AppConfig.identity]} alt="Logo" />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AuthPagesWrapper;